import { Link } from "react-router-dom";
import { MessageCircle, Clapperboard } from "lucide-react";
import Logo from "@/components/Logo";
import TikTokIcon from "@/components/TikTokIcon";
import { WHATSAPP_URL, TIKTOK_URL } from "@/lib/filters";

const LINKS = [
    { label: "Filters", hash: "#filters" },
    { label: "Features", hash: "#features" },
    { label: "AI Studio", hash: "#ai-studio" },
    { label: "How it works", hash: "#how" },
];

export default function Navbar() {
    const go = (e, hash) => {
        e.preventDefault();
        if (window.__lenis) window.__lenis.scrollTo(hash, { offset: -72 });
        else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-obsidian/70 backdrop-blur-xl">
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
                <Link to="/" data-testid="navbar-logo" aria-label="Deoeditz home">
                    <Logo />
                </Link>
                <nav className="hidden items-center gap-8 md:flex">
                    {LINKS.map((l) => (
                        <a
                            key={l.hash}
                            href={l.hash}
                            onClick={(e) => go(e, l.hash)}
                            className="text-sm font-semibold text-slate-300 transition-colors hover:text-amberx"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center gap-2.5">
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="navbar-whatsapp-button"
                        aria-label="Chat with Deoeditz on WhatsApp"
                        className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-slate-200 transition-colors hover:border-amberx hover:text-amberx"
                    >
                        <MessageCircle className="h-5 w-5" />
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="navbar-tiktok-button"
                        aria-label="Deoeditz on TikTok"
                        className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-slate-200 transition-colors hover:border-amberx hover:text-amberx"
                    >
                        <TikTokIcon className="h-5 w-5" />
                    </a>
                    <Link
                        to="/editor"
                        data-testid="navbar-editor-link"
                        className="inline-flex h-11 items-center gap-2 rounded-full bg-amberx px-5 font-display text-sm font-bold text-obsidian transition-transform hover:scale-[1.03] active:scale-95"
                    >
                        <Clapperboard className="h-4 w-4" />
                        <span className="hidden sm:inline">Open Editor</span>
                        <span className="sm:hidden">Editor</span>
                    </Link>
                </div>
            </div>
        </header>
    );
}
